import { useMutation } from '@apollo/client';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';
import { isEmpty } from 'lodash';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useRecoilState, useRecoilValue } from 'recoil';
import cartAtom from '~/services/cart/cart.atom';
import { PaymentMethods } from '~/services/payment';
import storeConfigAtom from '~/services/store-config/store-config.atom';
import { scrollToFirstError } from '~/utils/helper';
import { CREATE_PAYPAL_TOKEN_GQL, SET_PAYPAL_PAYMENT_METHOD_GQL } from './gql';

const PayPalButton = ({ disabled = false, isPlaceholder = true, onPlaceOrder, formik }: any) => {
    // const { paypal_lib_url } = {paypal_lib_url: 'https://www.sandbox.paypal.com/sdk/js?client-id=AU'}
    const storeConfig = useRecoilValue(storeConfigAtom.store);
    const [cart, setCart] = useRecoilState(cartAtom.cart);
    const [paypalScript, setPayPalScript] = useState('');
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);
    const router = useRouter();
    // const [getPayPalScript , {loading:loadingScript}] = useLazyQuery(QUERY_GET_PAYPAL_LIB_URL_GQL)
    const [createPaypalToken, { loading: loadingPaypalToken }]: any = useMutation(CREATE_PAYPAL_TOKEN_GQL, {
        onError: ({ message }) => {
            formik.setFieldError('selected_payment_method.' + PaymentMethods.PAYPAL_EXPRESS, message);
        }
    });

    useEffect(() => {
        if (storeConfig?.paypal_lib_url) {
            // getPayPalScript({
            //     onCompleted(data) {
            //         const paypal_lib_url = get(data, 'storeConfig.paypal_lib_url');
            //         if (paypal_lib_url) {
            setPayPalScript(storeConfig?.paypal_lib_url);
            //         }
            //     },
            // });
        }
    }, []);
    // const [placeOrder]: any = useMutation(PLACE_ORDER_GQL, {
    //     onCompleted: (res) => {
    //         toast.success('Congratulation, your order is completed');
    //         const placeOrder = res?.placeOrder;
    //         localStorage.setItem(placeOrder?.order?.order_number, convertCartInfo({ cart: cartInfo }));

    //         router.push(`${ROUTING_ORDER_SUCCESS}?id=${placeOrder?.order?.order_number}`);
    //     },
    //     onError: ({ message }) => {
    //         handleErrorGraphQL(message);
    //     }
    // });
    const [setPaymentMethod]: any = useMutation(SET_PAYPAL_PAYMENT_METHOD_GQL, {
        onError: ({ message }) => {
            handleErrorGraphQL(message);
        }
    });

    const handleErrorGraphQL = (message: any) => {
        setCart((prevCart: any) => ({
            ...prevCart,
            statusPlaceOrder: 'failed'
        }));
        try {
            const newMessage = JSON.parse(message);
            if (newMessage.message) {
                setMessage(newMessage.message);
                return toast.error(newMessage.message);
            } else {
                setMessage(message);
                return toast.error(message);
            }
        } catch (error) {
            return toast.error(message || message);
        }
    };
    const createOrder = async (data: any, actions: any) => {
        return formik.validateForm().then(async (res: any) => {
            if (!isEmpty(res)) {
                scrollToFirstError(res);
            } else {
                const result = await createPaypalToken({
                    variables: {
                        cartId: cart.cartId,
                        returnUrl: process.env.NEXT_PUBLIC_PAYPAL_RETURN_URL,
                        cancelUrl: process.env.NEXT_PUBLIC_PAYPAL_CANCEL_URL
                    }
                });
                return result?.data?.createPaypalExpressToken?.token;
            }
        });
    };

    const onApprove = async (data: any, actions: any) => {
        const { orderID, payerID, facilitatorAccessToken } = data;
        if (typeof window !== 'undefined') {
            window.scrollTo({
                top: 100,
                behavior: 'smooth'
            });
        }
        setCart((prevCart: any) => ({
            ...prevCart,
            statusPlaceOrder: 'processing'
        }));
        setPaymentMethod({
            variables: {
                cartId: cart.cartId,
                payerId: payerID,
                token: orderID
            },
            onCompleted(data: any) {
                onPlaceOrder();
            }
        });
    };
    const handleError = (error: any) => {
        setError(error);
        setCart((prevCart: any) => ({
            ...prevCart,
            statusPlaceOrder: 'failed'
        }));
        // formik.setFieldError("selected_payment_method."+PaymentMethods.PAYPAL_EXPRESS, error);
    };

    const clientId = paypalScript?.split('client-id=')?.[1]?.split('&')?.[0] || '';

    // if(loadingScript  ) return <div>Loading...</div>

    return (
        <>
            {message && typeof message === 'string' && (
                <div className=" alert alert-light alert-danger alert-icon alert-inline mb-4 p-2">
                    <i className="fas fa-exclamation-triangle"></i>
                    <h4 className="alert-title" style={{ overflow: 'auto' }}>
                        {message}
                    </h4>
                    <button type="button" className="btn btn-link btn-close" onClick={() => setMessage(null)}>
                        <i className="d-icon-times"></i>
                    </button>
                </div>
            )}
            {/* <LoadingPages text={'Your order is processing, please wait...'} loading={loading} /> */}
            {clientId && (
                <PayPalScriptProvider
                    options={{
                        clientId,
                        currency: 'USD',
                        disableFunding: isEmpty(storeConfig.paypal_disable_funding)
                            ? undefined
                            : storeConfig.paypal_disable_funding
                    }}
                >
                    <PayPalButtons
                        disabled={disabled}
                        createOrder={createOrder}
                        // // onApprove={onApprove}

                        // onError={handleError}

                        onApprove={onApprove}
                        className="w-full"
                        style={{ layout: 'vertical', label: 'paypal', tagline: false }}
                    />
                </PayPalScriptProvider>
            )}
        </>
    );
};

export default PayPalButton;
